import React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'typesafe-actions';
import { CssBaseline } from 'common/components/css-baseline';
import { ProductsCarouselProps } from 'features/products/components/products-carousel';
import { ThemeProvider } from 'fronton-react';
import { SponsoredProductsCarousel } from 'features/sponsored-carousel/components/products-carousel';

export type SponsoredCarouselEntryWidgetProps = {
  store: Store;
} & ProductsCarouselProps;

export const SponsoredCarouselEntryWidget: React.FC<SponsoredCarouselEntryWidgetProps> = ({
  store,
  ...props
}) => (
  <Provider store={store}>
    <SponsoredProductsCarouselWrapper {...props} />
  </Provider>
);

export const SponsoredProductsCarouselWrapper = (props: ProductsCarouselProps) => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <SponsoredProductsCarousel {...props} />
    </ThemeProvider>
  );
};
